import FindHelp from "../Components/FindHelp/findHelp";

//this is importing a component into a giveHelp page
export default function FindHelpPage() {
    return(
        <div>   
         <FindHelp/>
         </div>
    )
}